import { ToggleGroupCard, ToggleGroupCardItem } from '@/components/ui/toggle-group';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ActivityNotificationEnum } from 'src/graphql/schema';

type Props = {
  description: string;
  value: ActivityNotificationEnum;
  options: {
    value: ActivityNotificationEnum;
    icon: React.ElementType;
    label: string;
    description: string;
  }[];
  onChange: (value: ActivityNotificationEnum) => void;
};

const ActivityNotifications = ({ description, value, options, onChange }: Props) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Activity notifications</CardTitle>
        <CardDescription className="whitespace-pre-wrap">{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <ToggleGroupCard type="single" className="flex-col w-full" onValueChange={onChange} value={value}>
          {options.map(({ value, icon: Icon, label, description }) => (
            <ToggleGroupCardItem key={value} value={value} icon={Icon} title={label} description={description} />
          ))}
        </ToggleGroupCard>
      </CardContent>
    </Card>
  );
};

export default ActivityNotifications;
